/* Introdução
   ========================================================================== */

const introSwiper = new Swiper('.intro__swiper-container', {
  effect: 'fade',
  allowTouchMove: false,
});

const intro = {
  typeof: 'Intro',

  slideTo(index) {
    introSwiper.slideTo(index);
  },

  stop() {
    document.querySelector('.intro').style.display = 'none';
  }
};

/* Intertítulos
   ========================================================================== */

const intertitles = [].map.call(document.querySelectorAll('.intertitle'), (intertitle) => {
  return new Intertitle(intertitle);
});

/* Marcas d'àgua
   ========================================================================== */

const watermarks = [].map.call(document.querySelectorAll('.watermark'), (watermark) => {
  return new Watermark(watermark);
});

/* Linha do tempo
   ========================================================================== */

const timeline = new Timeline([intro, myGraphic, ...intertitles, ...watermarks], keyframes);

const init = function init() {
  document.querySelector('.grow').classList.add('grow--animate');
  sound.play();
  timeline.play();

  requestTimeout(() => {
    document.querySelector('.cover').style.display = 'none';
  }, 600);
}

const btnStart = document.querySelector('.btn-start');

btnStart.addEventListener('click', () => {
  init();
});

document.addEventListener('keypress', (event) => {
  switch (event.keyCode) {
    case 32:
      init();

      break;
    case 97:
      sound.seek(timeline.prev() / 1000);

      break;
    case 100:
      sound.seek(timeline.nextSlide() / 1000);

      break;
    case 102:
      sound.seek(timeline.nextChapter() / 1000);

      break;
    case 115:
      sound.seek(timeline.next() / 1000);

      break;
    }
});

/* Controles
   ========================================================================== */

const controls = document.querySelector('.controls');

const btnPrev = document.querySelector('.btn-prev');
const btnPlay = document.querySelector('.btn-play');
const btnPause = document.querySelector('.btn-pause');
const btnNext = document.querySelector('.btn-next');

btnPlay.style.display = 'none';

btnPrev.addEventListener('click', () => {
  sound.seek(timeline.prev() / 1000);
});

btnNext.addEventListener('click', () => {
  sound.seek(timeline.next() / 1000);
});

btnPlay.addEventListener('click', () => {
  timeline.play();
  sound.play();

  btnPlay.style.display = 'none';
  btnPause.style.display = '';
});

btnPause.addEventListener('click', () => {
  timeline.pause();
  sound.pause();

  btnPlay.style.display = '';
  btnPause.style.display = 'none';
});
